/*@ngInject*/
const PreferenceModel = function ($rootScope, $q, umsLog, xmlUtil) {

    let preferences = {},
        defaultPreferences = {},
        userPreferences = {},
        defaultPreferencePromise,
        userPreferencePromise;

    this.get = function (name, useViewWidgets=true) {
        let pref,
            columnPref,
            type;

        pref = _.get(preferences, name);

        if (name === 'view.agent.homePageColumns' || name === 'view.uw.homePageColumns' || name === 'view.tasksHomePageTaskColumnsForUnderwriter' || name === 'view.tasksHomePageTaskColumnsForAgent') {
            if (name === 'view.agent.homePageColumns' || name === 'view.uw.homePageColumns') {
                type = '1';
            } else if (name === 'view.tasksHomePageTaskColumnsForUnderwriter' || name === 'view.tasksHomePageTaskColumnsForAgent') {
                type = '2';
            }
            // submissionGrid columns from "view.widgets" is legacy, but have to keep it for UI column editting purpose
            if (useViewWidgets) {
              columnPref = this.getColumns(type);
            }
            if (!_.isNil(columnPref)) {
                let userPref = xmlUtil.parseString(_.get(_.clone(_.get(preferences, name)), 'value'));
                columnPref = this.reconcileWithUserPref(columnPref, userPref);
                return columnPref;
            } else {
                if (_.isPlainObject(pref)) {
                    pref = xmlUtil.parseString(_.get(pref, 'value'));
                } else {
                    return pref = xmlUtil.parseString(_.get(preferences, name));
                }
            }
        } else if (name === 'system.accountSubmissionsGridColumns' || name === 'system.accountOverviewSubmissionColumnsForUnderwriter' || name === 'system.accountOverviewSubmissionColumnsForAgent') {
            if (_.isPlainObject(pref)) {
                return pref = xmlUtil.parseString(_.get(pref, 'value'));
            } else {
                return pref = xmlUtil.parseString(pref);
            }

        } else {
            if (_.isPlainObject(pref)) {
                pref = _.get(pref, 'value');
            }
        }

        return pref;
    };

    this.reconcileWithUserPref = function (widgetPref, userPref) {
        _.each(userPref.column, function (userPrefColumn, index) {
            let widgetPrefColumn = _.find(widgetPref.column, function (column) {
                return column.__text === userPrefColumn.__text;
            });
            if (!_.isNil(widgetPrefColumn)) {
                userPref.column[index] = widgetPrefColumn;
            }
        });

        return userPref;
    };

    this.getColumns = function (type) {
        let columns,
            widgetsObject = xmlUtil.parseStringWithoutFlattening(this.get('view.widgets')),
            widgetArray;
        if (widgetsObject.widgets) {
            widgetArray = Array.isArray(widgetsObject.widgets.widget) ? widgetsObject.widgets.widget : [widgetsObject.widgets.widget];
            _.each(widgetArray, function (item) {
                if (item.type === type) {
                    if (!_.isNil(item.columns)) {
                        columns = item.columns;
                        return columns;
                    }
                }
            });
        }

        return columns;
    };

    this.set = function (key, value) {
        preferences[key] = value;
    };

    this.getAll = function () {
        return preferences;
    };

    this.isDefaultLoaded = function () {
        return !_.isEmpty(defaultPreferences);
    };

    this.isUserLoaded = function () {
        return !_.isEmpty(userPreferences);
    };

    this.setDefaultPreferences = function (defaultPrefs) {
        defaultPreferences = defaultPrefs;
        preferences = _.clone(defaultPreferences);
    };

    this.setUserPreferences = function (userPrefs) {
        userPreferences = userPrefs;
        preferences = _.assign(_.clone(defaultPreferences), _.clone(userPreferences));
    };

    this.getUserPreferences = function () {
        return userPreferences;
    };

    this.reset = function () {
        preferences = {};
        userPreferences = {};
        userPreferencePromise = null;
        defaultPreferencePromise = null;
    };
};

angular.module('umCore')
    .service('preferenceModel', PreferenceModel);
